import React from 'react';
import { Navigate } from 'react-router-dom';
import Dashboard from 'components/dashboards/default';
import { useAuth } from 'context/AuthContext';
import { WORKSPACE_MODES } from 'helpers/workspace';

const ModeDashboard = () => {
  const { getCurrentWorkspaceMode } = useAuth();
  const mode = getCurrentWorkspaceMode();

  if (mode === WORKSPACE_MODES.SUPERADMIN) {
    return <Navigate to="/super-admin" replace />;
  }

  if (mode === WORKSPACE_MODES.PARTNERS) {
    return <Navigate to="/partners" replace />;
  }

  if (mode === WORKSPACE_MODES.BLOG) {
    return <Navigate to="/blog" replace />;
  }

  return <Dashboard />;
};

export default ModeDashboard;
